import React from 'react';
import Breadcrumb from '../components/Breadcrumb';

const Impressum = () => {
  return (
    <div className="bg-white py-12">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb items={[{ label: 'Impressum' }]} />
        
        <h1 className="text-4xl font-bold text-[#0F172A] mb-8">Impressum</h1>
        
        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-gray-700">
              Schössow Dienstleistungen<br />
              Neben dem Brand 10<br />
              44135 Dortmund<br />
              Nordrhein-Westfalen, Deutschland
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Kontakt</h2>
            <p className="text-gray-700">
              <strong>Telefon:</strong> <a href="tel:+4923139085116" className="text-[#16A34A] hover:underline">0231 39085116</a><br />
              <strong>E-Mail:</strong> <a href="mailto:info@haushaltsaufloesung.services" className="text-[#16A34A] hover:underline">info@haushaltsaufloesung.services</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Vertreten durch</h2>
            <p className="text-gray-700">
              Geschäftsführung: [Name auf Anfrage]<br />
              Vertretungsberechtigt: [Angabe auf Anfrage]
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Umsatzsteuer-ID</h2>
            <p className="text-gray-700">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              [Nummer auf Anfrage]
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="text-gray-700">
              Schössow Dienstleistungen<br />
              Neben dem Brand 10<br />
              44135 Dortmund
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Streitschlichtung</h2>
            <p className="text-gray-700 mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#16A34A] hover:underline"> https://ec.europa.eu/consumers/odr</a>.
            </p>
            <p className="text-gray-700">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Haftung für Inhalte</h2>
            <p className="text-gray-700 mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu 
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-gray-700">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen 
              bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer 
              konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese 
              Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Haftung für Links</h2>
            <p className="text-gray-700">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0F172A] mb-4">Urheberrecht</h2>
            <p className="text-gray-700">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;